module.exports = __webpack_public_path__ + "img/P37.cbfdcc95.png";